export class MenuModule {
    constructor() {
        this.init();
    }

    init() {
        this.addListeners();
        this.ShowHideHeader();
    }
    

    addListeners() {
        $('.menu-module__button').on('click', (e) => { this.toggleMegaMenu(e) });
        $('.mega-menu__items .menu-item-has-children').on('click', (e) => { this.toggleMenuItem(e) });
        $('.search-module__button').on('click', (e) => { this.toggleSearch(e) });        
    }
    //Mega menu
    toggleMegaMenu(e) {
        if (this.megaMenuIsOpen()) {
            this.closeMegaMenu();
        } else {
            if (this.searchIsOpen()) {
                this.closeSearch();
            }
            this.openMegaMenu();
        }
    }
    openMegaMenu(e) {
        $('.mega-menu').addClass('active');
        $('.site-header__content').addClass('active');
        $('.menu-module__button .icon').addClass('icon--close');
        $('.menu-module__button .icon').removeClass('icon--menu');
        $('.menu-module__button .icon').addClass('icon-active');
    }
    closeMegaMenu(e) {
        $('.mega-menu').removeClass('active');
        $('.site-header__content').removeClass('active');
        $('.menu-module__button .icon').removeClass('icon--close');
        $('.menu-module__button .icon').addClass('icon--menu');
        $('.menu-module__button .icon').removeClass('icon-active');
    }
    megaMenuIsOpen() {
        return $('.mega-menu').hasClass('active');
    }
    toggleMenuItem(e) {
        if (e.target.tagName.toLowerCase() == 'li') {
            const $li = $(e.target);
            const $currentSubmenu = $li.find('.sub-menu');           
            $li.toggleClass('active');
            $currentSubmenu.toggleClass('active');
        }
    }
    //Search
    toggleSearch(e) {
        if (this.searchIsOpen()) {
            this.closeSearch();
        } else {
            if (this.megaMenuIsOpen()) {
                this.closeMegaMenu();
            }
            this.openSearch();
        }
    }
    openSearch(e) {
        $('.search-module__container').addClass('active');
        $('.site-header__content').addClass('active');
        $('.search-module__button .icon').addClass('icon--close');
        $('.search-module__button .icon').removeClass('icon--search');
        $('.search-module__button .icon').addClass('icon-active');
        $('input.search-module__input').focus();
    }
    closeSearch(e) {
        $('.search-module__container').removeClass('active');
        $('.site-header__content').removeClass('active');
        $('.search-module__button .icon').removeClass('icon--close');
        $('.search-module__button .icon').addClass('icon--search');
        $('.search-module__button .icon').removeClass('icon-active');
    }
    searchIsOpen() {
        return $('.search-module__container').hasClass('active');
    }



    ShowHideHeader() {
        // Hide/show header on scroll
        var didScroll;
        var lastScrollTop = 0;
        var delta = 100;
        var navbarHeight = $('header').outerHeight();


        // Check if scroll occured
        $(window).scroll(function(event){
            didScroll = true;
        });

        setInterval(function() {
            if (didScroll) {
                hasScrolled();
                didScroll = false;
            }
        }, 250);

        function hasScrolled() {
            var st = $(window).scrollTop();

            // Make sure they scroll more than delta
            if(Math.abs(lastScrollTop - st) <= delta)
                return;
                
            // If they scrolled down and are past the navbar, add class .nav-up.
            // This is necessary so you never see what is "behind" the navbar.
            if (st > lastScrollTop && st > navbarHeight){
                // Scroll Down
                $('header').removeClass('nav-down').addClass('nav-up');

                // Close search
                $('.search-module__container').removeClass('active');
                $('.site-header__content').removeClass('active');
                $('.search-module__button .icon').removeClass('icon--close');
                $('.search-module__button .icon').addClass('icon--search');
                $('.search-module__button .icon').removeClass('icon-active');
                // Close mega menu
                $('.mega-menu').removeClass('active');
                $('.site-header__content').removeClass('active');
                $('.menu-module__button .icon').removeClass('icon--close');
                $('.menu-module__button .icon').addClass('icon--menu');
                $('.menu-module__button .icon').removeClass('icon-active');
            } else {
                // Scroll Up
                if(st + $(window).height() < $(document).height()) {
                    $('header').removeClass('nav-up').addClass('nav-down');
                }
            }
            
            lastScrollTop = st;
        }
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/front/App/MenuModule.js